import { create } from '../../../node_modules/zustand/esm/index.js';
import { createReplacementUISlice } from './ReplacementStore.js';
import { createOrderReplacementSlice } from './OrderReplacement.js';

function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target};return _extends.apply(this,arguments)}const useReplacementFeatureStore=create()((...args)=>_extends({},createReplacementUISlice(...args),createOrderReplacementSlice(...args)));

export { useReplacementFeatureStore };
//# sourceMappingURL=index.js.map
